var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-row",
    [
      _c(
        "b-col",
        { attrs: { sm: "6", lg: "3" } },
        [
          _c(
            "b-card",
            { staticClass: "bg-widget", attrs: { "no-body": "" } },
            [
              _c("b-card-body", { staticClass: "pb-0" }, [
                _c("h4", { staticClass: "mb-0" }, [
                  _vm._v(_vm._s(_vm.portfolioVulnerabilities)),
                ]),
                _c("p", [
                  _vm._v(_vm._s(_vm.$t("message.portfolio_vulnerabilities"))),
                ]),
              ]),
              _c("widget-portfolio-vulnerabilities", {
                ref: "widgetPortfolioVulnerabilities",
                staticClass: "chart-wrapper px-3",
                staticStyle: { height: "70px" },
                attrs: { chartId: "card-chart-01", height: 70 },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-col",
        { attrs: { sm: "6", lg: "3" } },
        [
          _c(
            "b-card",
            { staticClass: "bg-widget", attrs: { "no-body": "" } },
            [
              _c("b-card-body", { staticClass: "pb-0" }, [
                _c("h4", { staticClass: "mb-0" }, [
                  _vm._v(_vm._s(_vm.vulnerableProjects)),
                ]),
                _c("p", [_vm._v(_vm._s(_vm.$t("message.projects_at_risk")))]),
              ]),
              _c("widget-projects-at-risk", {
                ref: "widgetPortfolioVulnerableProjects",
                staticClass: "chart-wrapper px-3",
                staticStyle: { height: "70px" },
                attrs: { chartId: "card-chart-02", height: 70 },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-col",
        { attrs: { sm: "6", lg: "3" } },
        [
          _c(
            "b-card",
            { staticClass: "bg-widget", attrs: { "no-body": "" } },
            [
              _c("b-card-body", { staticClass: "pb-0" }, [
                _c("h4", { staticClass: "mb-0" }, [
                  _vm._v(_vm._s(_vm.vulnerableComponents)),
                ]),
                _c("p", [
                  _vm._v(_vm._s(_vm.$t("message.vulnerable_components"))),
                ]),
              ]),
              _c("widget-vulnerable-components", {
                ref: "widgetPortfolioVulnerableComponents",
                staticClass: "chart-wrapper px-3",
                staticStyle: { height: "70px" },
                attrs: { chartId: "card-chart-03", height: 70 },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-col",
        { attrs: { sm: "6", lg: "3" } },
        [
          _c(
            "b-card",
            { staticClass: "bg-widget", attrs: { "no-body": "" } },
            [
              _c("b-card-body", { staticClass: "pb-0" }, [
                _c("h4", { staticClass: "mb-0" }, [
                  _vm._v(_vm._s(_vm.inheritedRiskScore)),
                ]),
                _c("p", [
                  _vm._v(_vm._s(_vm.$t("message.inherited_risk_score"))),
                ]),
              ]),
              _c("widget-inherited-risk-score", {
                ref: "widgetPortfolioInheritedRisk",
                staticClass: "chart-wrapper px-3",
                staticStyle: { height: "70px" },
                attrs: { chartId: "card-chart-04", height: 70 },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }